import React, { useEffect } from 'react';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { ImSpinner8 } from 'react-icons/im';
import { TbAlertTriangle, TbCheck, TbClick, TbClockExclamation, TbInfoSquareRounded, TbMapPinCheck, TbMapPinX, TbSearch, TbShoppingBagExclamation, TbShoppingBagSearch, TbUserSearch } from 'react-icons/tb';
import Button from '../Form/Button';
import { useNavigate } from 'react-router-dom';
import { useCartContext } from '../../Contexts/CartContext';
import DOMPurify from 'dompurify';
import { useStoreContext } from '../../Contexts/StoreContext';
import { useStoreHook } from '../../Hooks/StoreHook';

const LoadingMain = () => {
    const { mainLoadingIcon, setMainLoading, mainLoadingTitle, mainLoadingMessage, mainLoadingCloseButton, mainLoadingIconSuccess, mainLoadingIconError, hasError, mainLoadingIconInfo, mainLoadingIconSearch, mainLoadingIconNoSearchMap, mainLoadingIconNoSearchUser, mainLoadingIconMapCheck, mainLoadingIconErrorAddProduct, mainLoadingIconSearchCart, mainLoadingLabelCloseButton, mainLoadingAutoClose, mainLoadingIconStoreClosed, mainLoadingIconClick } = useLayoutContext();
    const { returnToCheckout, setReturnToCheckout } = useCartContext();
    const { loadStoreInfoOnCloseMainLoading, setLoadStoreInfoOnCloseMainLoading } = useStoreContext();
    const { currentStore } = useStoreContext();
    const { loadStoreInfo, getLinkToHome } = useStoreHook();

    const navigate = useNavigate();

    const handleClose = () => {
        if (returnToCheckout && !hasError) {
            navigate(`${getLinkToHome()}/checkout`);
            setReturnToCheckout(false);
        }
        if (loadStoreInfoOnCloseMainLoading) {
            loadStoreInfo(currentStore.id); //* atualiza informações da loja
            setLoadStoreInfoOnCloseMainLoading(false);
        }
        setMainLoading(false);
    }

    //* Fechamento automatico da modal
    useEffect(() => {
        if (mainLoadingAutoClose) {
            setTimeout(() => {
                handleClose();
            }, 5000);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mainLoadingAutoClose]);

    const mainLoadingTitleSanitize = DOMPurify.sanitize(mainLoadingTitle);
    const mainLoadingMessageSanitize = DOMPurify.sanitize(mainLoadingMessage);

    return (
        <div className='p-4 py-6 flex flex-col gap-3 items-center'>

            {
                !mainLoadingIconSuccess 
                && !mainLoadingIconError 
                && !mainLoadingIconInfo 
                && !mainLoadingIconSearch 
                && !mainLoadingIconNoSearchMap
                && !mainLoadingIconNoSearchUser
                && !mainLoadingIconMapCheck
                && !mainLoadingIconErrorAddProduct
                && !mainLoadingIconSearchCart
                && !mainLoadingIconStoreClosed
                && !mainLoadingIconClick
                && mainLoadingIcon && <ImSpinner8 size={35} className="animate-spin text-shopfood-title" />
            }
            {mainLoadingIconSuccess && <TbCheck size={55} className="text-shopfood-success zoomInIcon" />}
            {mainLoadingIconError && <TbAlertTriangle size={50} className="text-shopfood-title zoomInIcon" />}
            {mainLoadingIconInfo && <TbInfoSquareRounded size={50} className="text-shopfood-title zoomInIcon" />}
            {mainLoadingIconSearch && <TbSearch size={50} className="text-shopfood-success zoomInIcon" />}
            {mainLoadingIconNoSearchMap && <TbMapPinX size={50} className="text-shopfood-error zoomInIcon" />}
            {mainLoadingIconNoSearchUser && <TbUserSearch size={50} className="text-shopfood-error zoomInIcon" />}
            {mainLoadingIconMapCheck && <TbMapPinCheck size={50} className="text-shopfood-success zoomInIcon" />}
            {mainLoadingIconErrorAddProduct && <TbShoppingBagExclamation size={50} className="text-shopfood-error zoomInIcon" />}
            {mainLoadingIconSearchCart && <TbShoppingBagSearch size={50} className="text-custom-primary zoomInIcon" />}
            {mainLoadingIconStoreClosed && <TbClockExclamation size={50} className="text-shopfood-error zoomInIcon" />}
            {mainLoadingIconClick && <TbClick size={50} className="text-shopfood-error zoomInIcon" />}

            {(mainLoadingTitle || mainLoadingMessage) ?
                <>
                    <div className='flex flex-col w-full gap-2'>
                        {mainLoadingTitle && <span className="font-bold text-shopfood-title w-full text-center leading-5" dangerouslySetInnerHTML={{ __html: mainLoadingTitleSanitize }} />}
                        {mainLoadingMessage && <span className='text-sm w-full text-center leading-4 text-gray-500' dangerouslySetInnerHTML={{ __html: mainLoadingMessageSanitize }} />}
                    </div>
                    {mainLoadingCloseButton && <div className='flex justify-center mt-1 animate-fade-in'><Button onClick={() => handleClose()} className='px-6 text-sm'>{ mainLoadingLabelCloseButton }</Button></div>}
                </>
                : null
            }
        </div>
    );
};

export default LoadingMain;
